/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const GraceTrigger = {
    EntryStart: 'EntryStart',
    ExitDeadline: 'ExitDeadline'
} as const;
export type GraceTrigger = typeof GraceTrigger[keyof typeof GraceTrigger];

